import { format } from "date-fns";
import { Status } from "../../../utils/Status";
import { Rol } from "../../../utils/Rol";
import { copyText } from "../../../utils/ReporteUtils";

const Reporte = ({ data, onClick, navigate, user }) => {
  const listarCodigos = (reporte) => {
    if (reporte.cantidad > 1 && reporte.reporte_codigo.length > 0) {
      return (
        <div class="dropdown dropend">
          <button
            class="w-100 btn btn-outline-dark d-block px-1 py-1 mb-1 text-nowrap dropdown-toggle"
            style={{ fontSize: "10px" }}
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Entradas
          </button>
          <ul
            class="dropdown-menu bg-light p-0 border-0"
            aria-labelledby="dropdownMenuButton1"
          >
            {reporte.reporte_codigo.map((codigo) => (
              <label
                className="text-start btn btn-outline-dark d-block px-1 py-1 text-nowrap"
                style={{ fontSize: "10px" }}
              >
                <span className="text-uppercase">{codigo.status}</span>
                {` | ${codigo.codigo}`}
                <i class="ms-1 bi bi-ticket"></i>
                <button
                  className="d-none"
                  name="download-entrada"
                  onClick={(event) =>
                    onClick(event, { reporte: reporte, codigo: codigo.codigo })
                  }
                ></button>
              </label>
            ))}
          </ul>
        </div>
      );
    } else {
      return (
        <div class="dropdown dropend">
          <button
            class="w-100 btn btn-outline-dark d-block px-1 py-1 mb-1 text-nowrap dropdown-toggle"
            style={{ fontSize: "10px" }}
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Entradas
          </button>
          <ul
            class="dropdown-menu bg-light p-0 border-0"
            aria-labelledby="dropdownMenuButton1"
          >
            <label
              className="btn btn-outline-dark d-block px-1 py-1 text-nowrap"
              style={{ fontSize: "10px" }}
            >
              {`${reporte.status} | ${reporte.codigo}`}
              <i class="ms-1 bi bi-ticket"></i>
              <button
                className="d-none"
                name="download-entrada"
                onClick={(event) =>
                  onClick(event, { reporte: reporte, codigo: reporte.codigo })
                }
              ></button>
            </label>
          </ul>
        </div>
      );
    }
  };
  return (
    <tr>
      <td className="Grifter d-none d-md-table-cell">#{data.id}</td>
      <td className="d-none d-md-table-cell">
        {format(new Date(data.created_at), "dd/M/yyyy H:ii:s").toString()}
      </td>
      <td className="d-none d-md-table-cell">{data.evento.nombre}</td>
      <td className="d-none d-md-table-cell">
        <label
          className="btn btn-outline-dark d-block px-1 py-1 mb-1 text-nowrap"
          style={{ fontSize: "10px" }}
        >
          {data.nombre_cliente} <i class="ms-1 bi bi-copy"></i>
          <button
            className="d-none"
            onClick={() => copyText(data.nombre_cliente)}
          ></button>
        </label>
        <label
          className="btn btn-outline-dark d-block px-1 py-1 mb-1 text-nowrap"
          style={{ fontSize: "10px" }}
        >
          {data.email_cliente} <i class="ms-1 bi bi-copy"></i>
          <button
            className="d-none"
            onClick={() => copyText(data.email_cliente)}
          ></button>
        </label>
        <label
          className="btn btn-outline-dark d-block px-1 py-1 mb-1 text-nowrap"
          style={{ fontSize: "10px" }}
        >
          {data.telefono_cliente} <i class="ms-1 bi bi-copy"></i>
          <button
            className="d-none"
            onClick={() => copyText(data.telefono_cliente)}
          ></button>
        </label>
      </td>
      <td className="d-none d-md-table-cell">{listarCodigos(data)}</td>
      <td className="d-none d-md-table-cell">{data.entrada.nombre}</td>
      <td className="d-none d-md-table-cell">{data.fecha}</td>
      <td className="d-none d-md-table-cell">
        {parseFloat(data.unidad).toLocaleString("es-AR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </td>
      <td className="d-none d-md-table-cell">{data.cantidad}</td>
      <td className="d-none d-md-table-cell">
        {parseFloat(data.cantidad * data.unidad).toLocaleString("es-AR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </td>
      <td className="d-none d-md-table-cell">{data.codigo_descuento}</td>
      <td className="d-none d-md-table-cell">{`${data.descuento}%`}</td>
      <td className="d-none d-md-table-cell text-nowrap">{`
     ${parseFloat(data.cantidad * data.unidad).toLocaleString("es-AR", {
       minimumFractionDigits: 2,
       maximumFractionDigits: 2,
     })}
     
     `}</td>
      <td className="d-none d-md-table-cell text-nowrap">{`
      ${(
        parseFloat(data.cantidad * data.unidad) +
        ((data.cantidad * data.unidad) / 100) * data.comision -
        (((data.cantidad * data.unidad) / 100) * data?.descuento ?? 0)
      ).toLocaleString("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} 
      `}</td>
      <td className="d-none d-md-table-cell">
        <div class="dropdown">
          <button
            class="btn text-dark border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
            style={{ borderRadius: "10px" }}
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {data.status}
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <label className="btn m-0 p-0">
                <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                Activar
                <button
                  className="d-none"
                  name="estado"
                  onClick={(event) =>
                    onClick(event, { ...data, status: 'ACTIVO' })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0">
                <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                Inactivo
                <button
                  className="d-none"
                  name="estado"
                  onClick={(event) =>
                    onClick(event, { ...data, status: 'INACTIVO' })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0">
              <i class="text-warning mx-1 bi bi-exclamation-diamond-fill"></i>
                Reembolsar
                <button
                  className="d-none"
                  name="estado"
                  onClick={(event) =>
                    onClick(event, { ...data, status: 'REEMBOLSO' })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0">
                <i class="text-info mx-1 bi bi-recycle"></i>
                Rechazado
                <button
                  className="d-none"
                  name="estado"
                  onClick={(event) =>
                    onClick(event, { ...data, status: 'RECHAZADO' })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0 d-none">
                <i class="text-danger mx-1 bi bi-trash"></i>
                Liquidado
                <button
                  className="d-none"
                  name="estado"
                  onClick={(event) =>
                    onClick(event, { ...data, status: 'LIQUIDADO' })
                  }
                ></button>
              </label>
            </li>
          </ul>
        </div>
      </td>

      <td>
        <label className={`btn btn-success me-1 mb-1 `}>
          <i class="bi bi-ticket-perforated"></i>
          {data.decidir_id}
          <button
            className="d-none"
            name="payway"
            onClick={(e) => onClick(e, data.decidir_id)}
          ></button>
        </label>
      </td>
    </tr>
  );
};

export default Reporte;
